import React, {Component} from 'react';
import {DESTINATION_STAFF_TEAM_ID} from './../constants';
import SimpleEditor from '../../../components/editor/simple_editor';
import DropzoneImageField from '../../../components/fields/field_dropzone_image';
import {b64toBlob, toDataUrl} from '../../../components/helpers/helpers';
import _findIndex from 'lodash/findIndex';
import _find from 'lodash/find';
import ImageDialog from './ImageAddDetailsCrop';
import Dialog, {
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
} from 'material-ui/Dialog';
import {
    Button,
    Checkbox,
    Grid,
    Typography,
    TextField,
    FormControlLabel,
    Paper,
} from 'material-ui';
import Select from 'react-select';
import {Heading} from '../../../components/heading/heading';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';

class StaffNewForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projectsDialogOpen: false,
            openCropPopup: false,
            imageToCrop: null,
            imageToView: null,
            src: null,
            cropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        };
    }

    updateCheck() {
        this.setState((oldState) => {
            return {
                checked: !oldState.checked,
            };
        });
    }

    onTeamMemberClick = (option) => {
        this.setState({
            projectsDialogOpen: true,
        });
        this.props.fetchProjectsByDestination(option.id);
    };

    onImageClick = (image) => {
        if (image.new) {
            this.updateLocalStateWithSectionImages(
                image,
                this.props.staffImage
            );
            let croppedImage = this.props.staffImage.croppedImage;
            if (croppedImage) {
                toDataUrl(croppedImage, (cropUrl) => {
                    this.setCroppedImageInState(cropUrl);
                });
            }
        } else {
            const {title, alt, name, description, link} = this.props.staffImage;
            this.setState({
                openCropPopup: true,
                imageToCrop: null,
                imageToView: image,
                imageMeta: {
                    title,
                    alt,
                    name,
                    description,
                    link,
                },
            });
        }
    };

    updateLocalStateWithSectionImages(image, staffImage) {
        const {title, alt, name, description, link} = staffImage;
        this.setState({
            openCropPopup: true,
            imageToCrop: image,
            imageMeta: {
                title,
                alt,
                name,
                description,
                link,
            },
        });
    }

    setCroppedImageInState(croppedImage) {
        this.setState({
            cropResult: croppedImage,
        });
    }

    updateState() {
        this.setState({
            openCropPopup: false,
            imageToCrop: null,
            src: null,
            cropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        });
    }

    render() {
        const {
            destinations,
            sites,
            jobs,
            teams,
            titles,
            classes,
            touched,
            loading,
            onSubmit,
            staffImage,
            onUpdateImageField,
            onDeleteImageField,
            onCropImage,
            onImageMetaUpdate,
        } = this.props;

        let destinationIndex = _findIndex(this.props.selectedStaffTeams, {
            id: DESTINATION_STAFF_TEAM_ID,
        });

        let showDestinations = destinationIndex > -1;

        let selectedDestinationsForDisplay = [];

        this.props.selectedDestinations.forEach((item) => {
            if (Object.keys(item).includes('display_name')) {
                selectedDestinationsForDisplay.push({
                    id: item.id,
                    display_name: item.display_name,
                    projects: item.projects ? item.projects : [],
                });
            } else {
                selectedDestinationsForDisplay.push({
                    id: item.destination_id,
                    display_name: item.destination_name,
                    projects: item.projects ? item.projects : [],
                });
            }
        });

        let selectedDestination = _find(selectedDestinationsForDisplay, {
            id: this.props.selectedDestinationId,
        });

        let selectedProjects = [];

        if (selectedDestination !== undefined) {
            selectedProjects = selectedDestination.projects;
        }

        let imageObj = staffImage != null ? staffImage : {};

        return [
            <div key="0">
                <Heading title={'Add Staff Member'} />
                <Grid container id="title-select">
                    <Grid item xs={12} md={2}>
                        <Typography variant="subheading">
                            Staff title *
                        </Typography>
                        <Select
                            name="title"
                            value={this.props.selectedTitle}
                            onChange={(selectedTitle) => {
                                this.props.onTitleChange(selectedTitle);
                            }}
                            options={titles}
                            clearable={false}
                            labelKey={'display_name'}
                            valueKey={'id'}
                        />
                    </Grid>
                </Grid>
                <Grid container id="staff-text-fields">
                    <Grid item xs={12} md={6}>
                        <TextField
                            id="firstName"
                            label="First Name"
                            value={this.props.selectedFirstName}
                            onChange={(ev) => {
                                this.props.onFirstNameChange(ev.target.value);
                            }}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            id="name"
                            label="Surname"
                            value={this.props.selectedName}
                            onChange={(ev) => {
                                this.props.onNameChange(ev.target.value);
                            }}
                            fullWidth
                            required
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    id="description-editor"
                    className={classes.staffRows}
                >
                    <Grid item xs={12} md={12}>
                        <Typography variant="subheading">
                            Description *
                        </Typography>
                        <SimpleEditor
                            initialValue={this.props.selectedDescription}
                            onChange={(htmlBody) => {
                                this.props.onDescriptionChange(htmlBody);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    id="multi-select-fields-teams"
                    className={classes.staffRows}
                >
                    <Grid item xs={12} md={6}>
                        <Typography variant="subheading">
                            Staff member team(s) *
                        </Typography>
                        <Select
                            name="teams"
                            multi
                            closeOnSelect={false}
                            value={this.props.selectedStaffTeams}
                            onChange={(selectedTeams) => {
                                this.props.onTeamsChange(selectedTeams);
                            }}
                            options={teams}
                            labelKey={'display_name'}
                            valueKey={'id'}
                            placeholder={'Type to search and select teams...'}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="subheading">
                            Staff member job(s) *
                        </Typography>
                        <Select
                            name="jobs"
                            multi
                            closeOnSelect={false}
                            value={this.props.selectedJobs}
                            onChange={(selectedJobs) => {
                                this.props.onJobsChange(selectedJobs);
                            }}
                            options={jobs}
                            labelKey={'display_name'}
                            valueKey={'id'}
                            placeholder={'Type to search and select jobs...'}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    id="multi-select-fields-sites"
                    className={classes.staffRows}
                >
                    <Grid item xs={12} md={6}>
                        <Typography variant="subheading">
                            Staff member site(s) *
                        </Typography>
                        <Select
                            name="sites"
                            multi
                            closeOnSelect={false}
                            value={this.props.selectedSites}
                            onChange={(selectedSites) => {
                                this.props.onStaffSitesChange(selectedSites);
                            }}
                            options={sites}
                            labelKey={'display_name'}
                            valueKey={'id'}
                            placeholder={'Type to search and select sites...'}
                        />
                    </Grid>
                    {showDestinations && (
                        <Grid item xs={12} md={6}>
                            <Typography variant="subheading">
                                Choose staff member destination(s) *
                            </Typography>
                            <Select
                                name="destinations"
                                multi
                                closeOnSelect={false}
                                value={selectedDestinationsForDisplay}
                                onChange={(selectedDestinations) => {
                                    this.props.onDestinationChange(
                                        selectedDestinations
                                    );
                                }}
                                options={destinations}
                                labelKey={'display_name'}
                                valueKey={'id'}
                                valueRenderer={(option) => (
                                    <span
                                        onClick={(e) =>
                                            this.onTeamMemberClick(option)
                                        }
                                    >
                                        {option.display_name}
                                    </span>
                                )}
                                placeholder={
                                    'Type to search and select destinations...'
                                }
                            />
                            <Typography variant="subheading">
                                Please click on each destination if you wish to
                                edit projects!
                            </Typography>
                        </Grid>
                    )}
                </Grid>
                <Grid container id="staff-photo" className={classes.staffRows}>
                    <Grid item xs={12}>
                        <Typography variant="subheading">
                            Staff Image
                        </Typography>
                        <Paper className={classes.staffImageField}>
                            <DropzoneImageField
                                images={staffImage}
                                multiple={false}
                                onImageDelete={(image) => {
                                    onDeleteImageField(image);
                                }}
                                onImageClick={this.onImageClick.bind(this)}
                                onImagesDrop={(image) => {
                                    onUpdateImageField(image);
                                }}
                            />
                            {imageObj.new && (
                                <h4 className="errMsg">
                                    Once you have selected an image please click
                                    on it in order to CROP it. Crop is
                                    mandatory!
                                </h4>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
                <Grid
                    container
                    id="staff-buttons"
                    className={classes.staffRows}
                >
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={!touched || loading}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                            onClick={onSubmit}
                        />
                        <BackButton
                            link={'/staff'}
                            style={{marginRight: 15}}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </div>,

            <ImageDialog
                key="1"
                classes={classes}
                cropResult={this.state.cropResult}
                imageToCrop={this.state.imageToCrop}
                imageRatios={this.props.imageRatios}
                open={this.state.openCropPopup}
                imageMeta={this.state.imageMeta}
                setAltField={(alt) => {
                    this.setState({
                        imageMeta: {
                            ...this.state.imageMeta,
                            alt,
                        },
                    });
                }}
                setTitleField={(title) => {
                    this.setState({
                        imageMeta: {
                            ...this.state.imageMeta,
                            title,
                        },
                    });
                }}
                setDescriptionField={(description) => {
                    this.setState({
                        imageMeta: {
                            ...this.state.imageMeta,
                            description,
                        },
                    });
                }}
                setLinkField={(link) => {
                    this.setState({
                        imageMeta: {
                            ...this.state.imageMeta,
                            link,
                        },
                    });
                }}
                setNameField={(name) => {
                    this.setState({
                        imageMeta: {
                            ...this.state.imageMeta,
                            name,
                        },
                    });
                }}
                setCropResult={(cropResult) => {
                    this.setState({
                        cropResult,
                    });
                }}
                handleSubmit={() => {
                    if (this.state.cropResult) {
                        let imageObject = b64toBlob(this.state.cropResult);
                        const imageUrlBlob = URL.createObjectURL(imageObject);
                        onCropImage(imageObject, imageUrlBlob, imageObject);
                    }
                    onImageMetaUpdate(this.state.imageMeta);
                    this.updateState();
                }}
                handleClose={() => {
                    this.updateState();
                }}
            />,

            <Dialog maxWidth="md" open={this.state.projectsDialogOpen} key="2">
                <DialogTitle>Select Projects</DialogTitle>
                <DialogContent>
                    {this.props.allProjectsByDestination.length < 1 ? (
                        <Typography variant="subheading" color="error">
                            There are no projects for this destination!
                        </Typography>
                    ) : (
                        <DialogContentText>
                            {this.props.allProjectsByDestination.map(
                                (item, index) => {
                                    let isSelectedProject =
                                        _findIndex(selectedProjects, {
                                            id: item.id,
                                        }) > -1;

                                    return (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isSelectedProject}
                                                    onChange={(ev, checked) => {
                                                        if (checked) {
                                                            this.props.projectAddForDestination(
                                                                item.id
                                                            );
                                                        } else {
                                                            this.props.projectRemoveForDestination(
                                                                item.id
                                                            );
                                                        }
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label={item.display_name}
                                            key={item.id}
                                        />
                                    );
                                }
                            )}
                        </DialogContentText>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            this.setState({
                                projectsDialogOpen: false,
                            });
                        }}
                        variant="raised"
                        style={{marginRight: 15}}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            this.setState({
                                projectsDialogOpen: false,
                            });
                        }}
                        variant="raised"
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>,
        ];
    }
}

export default StaffNewForm;



// WEBPACK FOOTER //
// ./src/containers/staff/forms/StaffCreateForm.jsx